import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-device",
  "use": "icon-device-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 28 28\" id=\"icon-device\"><g fill=\"none\"><path d=\"M8.35 3a3.5 3.5 0 0 0-3.378 2.58L2.143 15.946C1.45 18.492 3.365 21 6.003 21h15.994c2.638 0 4.554-2.508 3.86-5.053L23.028 5.58A3.5 3.5 0 0 0 19.651 3H8.349zM6.42 5.974A2 2 0 0 1 8.35 4.5h11.3a2 2 0 0 1 1.93 1.474l2.83 10.368a2.5 2.5 0 0 1-2.413 3.158H6.003a2.5 2.5 0 0 1-2.412-3.158L6.419 5.974zM7.747 22.5a.75.75 0 1 0 0 1.5h12.503a.75.75 0 1 0 0-1.5H7.748z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/device.svg
// module id = k6Cd
// module chunks = 69